import {observable, action} from 'mobx';
import baseApi from '../../tool/base';
import {message} from 'antd';

const searchValue = {
  productName: '',
  isFree: '-1', //'1':免费; '0': 收费
  ifFb: '-1',//'1':非标; '0': 标准
  productNumber: '',
  productPrice: '',
  productTypeName: '',
  tradeName:'',
  inter: '',
  ec: '',
  database: '',
};
export class PriceStore{

    routing = null;
    constructor(routing){
        this.routing = routing;
        this.getPriceInfoList = this.getPriceInfoList.bind(this);
        this.setSearchValue = this.setSearchValue.bind(this);
        this.resetSearchValue = this.resetSearchValue.bind(this);
        this.setPage = this.setPage.bind(this);
        this.editPriceInfoList = this.editPriceInfoList.bind(this);
        this.setPriceInfoList = this.setPriceInfoList.bind(this);
        this.addAuth = this.addAuth.bind(this);
    }

    @observable priceInfoList = [];
    @observable me  = {};
    @observable page = {current:1,pageSize:10,total:0};
    @observable loading = false;
    @observable searchValue = searchValue;
    @observable routes = [
      {
        key: '1',
        breadcrumbName: '云商店',
        path: '/',
      },
      {
        key: '2',
        breadcrumbName: '应用价格',
        path: '/app/price',
      }
    ];
    @observable auth = {}
    @action
    getPriceInfoList(){
        let ec_id;
        if(!localStorage.me){
            message.info("请先登录!");
        }else{
            ec_id = JSON.parse(localStorage.me).member.ec_id;
          let params = {
            pageNum:this.page.current,
            pageSize: this.page.pageSize,
            ...this.searchValue,
          }
          params.isFree === '-1' && delete params.isFree;
          params.ifFb=== '-1' && delete params.ifFb;
          params['ecId'] = ec_id;
          this.loading = true;
          baseApi.callApi("/product/price/list",'GET',params,'json','text')
            .then((priceData,reject)=>{
               // console.log(JSON.stringify(priceData) + "------" + priceData.code);
                if(priceData && priceData.code === 0){
                    message.error(priceData.errMsg);
                    this.loading = false;
                }else{
                    let priceList = priceData.data.data;
                    priceList.forEach(function (priceInfo,index) {
                        priceInfo['key'] = index+1;
                        priceInfo['auth'] = priceData.auth;
                    });

                    this.priceInfoList = priceList;
                    this.page.total = priceData.data.count;
                    this.auth = priceData.auth;
                    this.loading = false;
                }
            })
            .catch((err)=>{
              console.log(err);
            });
        }
    }

    @action

    setSearchValue(params = {}) {
      this.searchValue = {...this.searchValue,...params};
    }

    setPage(params = {}) {
      this.page =  {...this.page,...params};
    }

    resetSearchValue() {
      this.searchValue = searchValue;
      this.getPriceInfoList();
    }

    setPriceInfoList(record = {},value = {}){
      this.priceInfoList.forEach((item,index) => {
        if(item.swId === record.swId) this.priceInfoList[index] = {...item,...value};
      })
    }

    editPriceInfoList(record = {},value = {}) {
      let loginUser = localStorage.me;
      let ecId = JSON.parse(loginUser).member.ec_id;
      let params = {swId:record.swId ,...value};
      baseApi.callApi("/product/price?ecId="+ecId,'PUT',params,'json','json')
        .then((data,reject)=>{
            if(data && data.code === 0){
                message.error(data.errMsg);
            }else{
                this.getPriceInfoList();
            }
        })
        .catch((err)=>{
          console.log(err);
          message.error("系统错误，请联系管路员");
        });
    }

  addAuth(params = {}) {
    baseApi.callApi("/product/price/addAuth/"+params.tel,'POST',params,'json','json')
      .then((data,reject)=>{
        if(data && data.code === 0){
          message.error(data.errMsg);
        }else{
          message.success('设置成功！');
        }
      })
      .catch((err)=>{
        console.log(err);
        message.error("系统错误，请联系管路员");
      });
  }

}





// WEBPACK FOOTER //
// ./src/stores/price/PriceStore.js